import { render, staticRenderFns } from "./createQrcode.vue?vue&type=template&id=2ba5c0e7&"
import script from "./createQrcode.vue?vue&type=script&lang=js&"
export * from "./createQrcode.vue?vue&type=script&lang=js&"
import style0 from "./createQrcode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba5c0e7')) {
      api.createRecord('2ba5c0e7', component.options)
    } else {
      api.reload('2ba5c0e7', component.options)
    }
    module.hot.accept("./createQrcode.vue?vue&type=template&id=2ba5c0e7&", function () {
      api.rerender('2ba5c0e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/createQrcode.vue"
export default component.exports